import { Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomInput from "../../components/CustomInput";
import logo from "../../asstes/asd.png";
import FormControlLabelPlacement from "../../components/FormControlLabelPlacement";
import CustomizedSnackbars from "../../components/CustomizedSnackbars";
import { FileLoader, LoginApi } from "../../constants/Constants";
import {
  AWS_Access_Key_Id_Encypt,
  AWS_Region,
  AWS_Secret_Access_Key_Encypt,
} from "../../constants/bucketCostant";
import axios from "axios";
import cogoToast from "cogo-toast";

const ConnectBucket = () => {
  const [accessKey, setAccessKey] = useState(AWS_Access_Key_Id_Encypt());
  const [secretAccessKey, setSecretAccessKey] = useState(
    AWS_Secret_Access_Key_Encypt()
  );
  const [bucketName, setBucketName] = useState("test-mrc");
  const [dcmcAccessKey, setDCMCAccessKey] = useState(
    process.env.React_App_User_DCMC_Access_Key_encypt
  );
  const [bucketType, setBucketType] = useState("aws");
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [Region, setRegion] = useState(AWS_Region());
  let token = localStorage.getItem("token");

  function CheckConnectivityMain() {
    var data = {
      bucketname: bucketName,
      awsAccessKeyId: accessKey,
      awsSecretAccessKey: secretAccessKey,
      DCMCAccessKey: dcmcAccessKey,
      BucketType: bucketType,
      Region: Region,
    };
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // STOP! Do not add the following header!
        // 'Content-Type': 'multipart/form-data'
      }),
      body: JSON.stringify(data),
    };
    // fetch('https://app.dcmcloud.com/api/files/CheckConnectivity?BucketName=' + BucketName + '&Accesskey=' + AccessKeyId + '&SecretAccessKey=' + SecretAccessKey + '&bucketType=google&dcmcAccessKey=eWF2b3ktMjFhNmQuYXBwc3BvdC5jb21fZGNtY2xvdWQ=', requestOptions)
    fetch(`${FileLoader}/fileloaderv1/files/CheckConnectivity`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data == true) {
          //setAwsActive(true);
          localStorage.setItem(
            "BucketCredential",
            JSON.stringify({
              AccessKey: accessKey,
              SecretAccessKey: secretAccessKey,
              BucketName: bucketName,
              Region: Region,
            })
          );
          localStorage.setItem(
            "BucketCredentialEncypt",
            JSON.stringify({
              AccessKey: accessKey,
              SecretAccessKey: secretAccessKey,
              BucketName: bucketName,
              Region: Region,
            })
          );
        } else {
          //setAwsActive(false);
          // document.getElementById('btnConnect').style.background = 'red';
          setIsOpen(true);
          setMessage("Bucket Connection Failed.");
          setSeverity("error");
          setTimeout(() => {
            setIsOpen(false);
          }, 3000);
        }
      });
  }
  const EncpytApi = async (value, key) => {
    let localKey =
      JSON.parse(localStorage.getItem("BucketCredentialEncypt")) || {};
    try {
      let formData = new FormData();
      formData.append("value", value);
      let response = await axios.post(
        `${FileLoader}/fileloaderv1/files/Encrypt`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        localKey[key] = response.data.encryptedText;
        localStorage.setItem(
          "BucketCredentialEncypt",
          JSON.stringify(localKey)
        );
        //console.log(localKey, "localKey");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const ConnectBucket = async () => {
    let id = JSON.parse(localStorage.getItem("userData"));
    try {
      let data = {
        user: id._id,
        accessKeyId: accessKey,
        secretAccessKey: secretAccessKey,
        bucketName: bucketName,
        dcmcAccessKey: dcmcAccessKey,
        bucketType: "aws",
      };
      let response = await axios.post(
        `${LoginApi}/api/v1/bucket/addBucket`,
        data,
        {
          headers: {
            // "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        cogoToast.success("Bucket Connected Successfully.", {
          position: "top-right",
        });
        localStorage.setItem(
          "BucketCredential",
          JSON.stringify({
            Region: Region,
            BucketName: bucketName,
            SecretAccessKey: secretAccessKey,
            AccessKey: accessKey,
          })
        );
        //console.log("localKey");
        await EncpytApi(accessKey, "AccessKey");
        await EncpytApi(secretAccessKey, "SecretAccessKey");
      }
    } catch (error) {
      //console.log(error);
      cogoToast.error("Failed to connect Bucket.", { position: "top-right" });
    }
  };

  const setValue = (e) => {
    if (e.target.name == "AccessKeyID") {
      setAccessKey(e.target.value);
    }
    if (e.target.name == "SecretAccessKey") {
      setSecretAccessKey(e.target.value);
    }
    if (e.target.name == "DCMCAccesskey") {
      setDCMCAccessKey(e.target.value);
    }
    if (e.target.name == "BucketName") {
      setBucketName(e.target.value);
    }
    if (e.target.name == "Region") {
      setRegion(e.target.value);
    }
  };
  return (
    <>
      <Grid
        container
        style={{ width: "100%", display: "flex", justifyContent: "center" }}
      >
        <Grid
          item
          md={4.5}
          xs={1}
          sx={{
            textAlign: "center",
            flexDirection: "column",
            maxWidth: { xs: "90%", sm: "70%", md: "40%" }, // Responsive max-width
          }}
          className="innerConnectBucket flex backgroundBucket mobileDisplayNone "
        >
          <div style={{ width: "90%", height: "30%" }} className="flex">
            <Typography variant="h5">
              <b style={{ color: "white" }}>
                Connect Your AWS/GOOGLE Bucket Here
              </b>
            </Typography>
          </div>
          <div style={{ width: "90%", height: "70%" }}></div>
        </Grid>
        <Grid
          item
          container
          className="innerConnectBucket2 flex "
          md={3.5}
          xs={11}
          sx={{
            height: "90%",
            maxWidth: { xs: "90%", sm: "70%", md: "40%" }, // Responsive max-width
          }}
          // style={{ height: "90%", maxWidth: '60%' }}
        >
          <Grid item style={{ width: "100%" }}>
            <div
              style={{ width: "100%", marginBottom: "20px" }}
              className="flex"
            >
              <img src={logo} width="150px"></img>
            </div>
            <CustomInput
              value={accessKey}
              label="AccessKey ID"
              name="AccessKeyID"
              setValue={setValue}
            />
            <CustomInput
              value={secretAccessKey}
              label="Secret Access Key"
              name="SecretAccessKey"
              setValue={setValue}
            />
            {/* <CustomInput value={process.env.React_App_AWS_Bucket_Name_encypt1} label="Bucket Name" /> */}
            <CustomInput
              value={bucketName}
              label="Bucket Name"
              name="BucketName"
              setValue={setValue}
            />

            <CustomInput
              value={dcmcAccessKey}
              label="DCMC Access key"
              name="DCMCAccesskey"
              setValue={setValue}
            />
            <CustomInput
              value={Region}
              label="Region"
              name="Region"
              setValue={setValue}
            />
            <FormControlLabelPlacement
              value={bucketType}
              setValue={setBucketType}
            />
            <div className="flex">
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
                style={{
                  background: "#5582c3",
                  padding: "8.5px 6px",
                  fontSize: "inherit",
                  width: "90%",
                }}
                onClick={() => {
                  ConnectBucket();
                  CheckConnectivityMain();
                }}
                // disabled={true}
              >
                Connect
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default ConnectBucket;
